// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.formClass[data-v-01673bcb] {\n  height: calc(100vh - 138px);\n  overflow-y: auto;\n  padding: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
